import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 13.5v-4L13.5 15V5.5l-3-2V15L5 9.5v4l7 7 7-7z" />
  </svg>
);

export default SvgArrowDown;
